import { Box, Chip, ChipOwnProps, Typography } from "@mui/material";
import { DBAccount } from "../../../api/types";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { timeAgoToStr } from "../../../utils/utils";
import {
  disguiseAddress,
  disguiseName,
  useDisguise,
} from "../../../context/disguiseContext";
import { accountExchange, stripOwnerPrefix } from "../accountCategories";

const timeAgoTagColor = (ms: number): ChipOwnProps["color"] => {
  const days = ms / 1000 / 60 / 60 / 24;

  if (days <= 5) {
    return "success";
  }

  if (days <= 10) {
    return "info";
  }

  if (days <= 21) {
    return "warning";
  }

  if (days < 365 * 10) {
    return "error";
  }

  return "secondary";
};

export const AccountTileTitle = ({
  isOpen,
  account,
}: {
  isOpen: boolean;
  account: DBAccount;
}) => {
  const isMobile = useIsMobile();
  const { enabled: disguise } = useDisguise();
  const rawName = stripOwnerPrefix(
    account.displayName ?? account.name,
    account.owner,
  );
  const displayName = disguiseName(rawName, disguise);
  const exchange = accountExchange(account);
  const equity = Math.round(account.totalEquity);
  const isHolding = (account.currentHoldings?.length ?? 0) > 0;

  const holdingColor = isHolding ? "info" : "";

  const color = account.active ? holdingColor : "gray";

  const mostRecentTime = new Date(
    account.summary?.mostRecentPosition?.openPositionTimestamp ?? 0,
  ).getTime();

  const timeAgo = timeAgoToStr(Date.now() - mostRecentTime);
  const tagColor = timeAgoTagColor(Date.now() - mostRecentTime);

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      <Typography color={color} variant="h6">
        {displayName}
      </Typography>
      {/* <h3>
        {account.displayName ?? account.name}
        {(numOfAccounts || 1) > 1 ? ` [${numOfAccounts}]` : ""}
      </h3> */}
      {/* <Typography sx={{ pl: 1 }}>${Math.round(account.totalEquity)}</Typography> */}

      {isMobile ? null : (
        <Chip
          color="success"
          variant="outlined"
          sx={{ ml: 1 }}
          size="small"
          label={"$" + equity}
        />
      )}

      {isMobile ? null : (
        <Chip
          color={tagColor}
          variant="outlined"
          sx={{ ml: 1 }}
          size="small"
          label={timeAgo}
        />
      )}

      {isMobile || !exchange ? null : (
        <Chip
          variant="outlined"
          sx={{ ml: 1, color: "text.secondary" }}
          size="small"
          label={exchange}
        />
      )}

      <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
        {isMobile ? (
          <Chip
            color="success"
            variant="outlined"
            sx={{ ml: 1, mr: 2 }}
            size="small"
            label={"$" + equity}
          />
        ) : null}

        <h3 style={{ fontFamily: "monospace" }}>
          {isMobile
            ? ""
            : disguiseAddress(account.hyperliquidAddress, disguise)}
        </h3>
        {isOpen ? (
          <ExpandLess fontSize="large" />
        ) : (
          <ExpandMore fontSize="large" />
        )}
      </Box>
    </Box>
  );
};
